module.exports = __webpack_public_path__ + "static/media/station-shop-sign@2x.17360fe0.png";